'use client'
import {
  Select_default
} from "./chunk-RH3SA7KZ.mjs";
import {
  Input_default
} from "./chunk-OCLOL5BZ.mjs";

// src/MobileInput/MobileInput.tsx
import { useEffect, useMemo, useRef } from "react";
import { COUNTRIES } from "@wbk/utils";
import { jsx, jsxs } from "react/jsx-runtime";
var MobileInput = ({
  label,
  country,
  mobile,
  onChange,
  error,
  disabled,
  required,
  className,
  autoFocus,
  placeholder,
  lang,
  hideErrorSpace = true,
  portal,
  ref
}) => {
  var _a, _b, _c, _d;
  const wrapperRef = useRef(null);
  const mobileRef = useRef(null);
  const countriesOptions = COUNTRIES.map((c) => {
    const name = c[`name_${lang}`] || c.name;
    return {
      value: c.code,
      text: `${name}-+${c.dial_code}`,
      id: c.code,
      icon: /* @__PURE__ */ jsx(
        "img",
        {
          className: "shrink-0",
          src: `https://wbk-assets.s3.me-south-1.amazonaws.com/flags/w80/${c.code.toLowerCase()}.png`,
          width: 20,
          height: 14,
          alt: name
        }
      )
    };
  });
  useEffect(() => {
    if (autoFocus && mobileRef.current) {
      mobileRef.current.focus();
    }
  }, []);
  const selectedCountry = useMemo(() => {
    return COUNTRIES.find((c) => c.code === (country == null ? void 0 : country.code));
  }, [country == null ? void 0 : country.code]);
  const handleCountry = (code) => {
    var _a2;
    const country2 = COUNTRIES.find((c) => c.code === code);
    if (!country2)
      return;
    onChange("country", country2);
    (_a2 = mobileRef.current) == null ? void 0 : _a2.focus();
  };
  return /* @__PURE__ */ jsxs("fieldset", { disabled, className, children: [
    label && /* @__PURE__ */ jsx("legend", { className: `pb-1 font-semibold ${disabled ? "text-text-secondary" : ""}`, children: label }),
    /* @__PURE__ */ jsxs("div", { className: "flex w-full items-baseline rtl:flex-row-reverse", ref: wrapperRef, children: [
      /* @__PURE__ */ jsxs("div", { className: "relative w-full max-w-[105px] shrink-0", children: [
        /* @__PURE__ */ jsx("label", { htmlFor: "country_code", className: "sr-only", children: "Country Code" }),
        /* @__PURE__ */ jsx(
          Select_default,
          {
            value: selectedCountry == null ? void 0 : selectedCountry.code,
            options: countriesOptions,
            "data-testid": "auth_countrycode_selector",
            onChange: ({ value: code }) => handleCountry(code),
            className: "rounded-r-none border-r-0 rtl:rounded-r-none",
            dir: "ltr",
            portal,
            positionRef: wrapperRef,
            renderLabel: (option) => {
              var _a2;
              return (_a2 = option.text) == null ? void 0 : _a2.split("-")[1];
            },
            autoSelect: true,
            renderOption: (option) => {
              var _a2;
              const [name, dialCode] = ((_a2 = option.text) == null ? void 0 : _a2.split("-")) || [];
              return /* @__PURE__ */ jsxs("div", { className: "flex w-full items-center justify-between overflow-hidden", children: [
                /* @__PURE__ */ jsxs("div", { className: "flex w-full grow items-center gap-2", children: [
                  /* @__PURE__ */ jsx(
                    "img",
                    {
                      className: "shrink-0",
                      src: `https://wbk-assets.s3.me-south-1.amazonaws.com/flags/w80/${option.value.toLowerCase()}.png`,
                      height: 14,
                      width: 20,
                      alt: name
                    }
                  ),
                  /* @__PURE__ */ jsx("span", { className: "block flex-1 truncate px-2", children: name })
                ] }),
                /* @__PURE__ */ jsx("div", { dir: "ltr", children: dialCode })
              ] });
            }
          }
        )
      ] }),
      /* @__PURE__ */ jsx("div", { className: "z-10 flex-grow", children: /* @__PURE__ */ jsx(
        Input_default,
        {
          className: "rounded-r-S",
          dir: "ltr",
          placeholder: selectedCountry ? `${((_b = (_a = selectedCountry == null ? void 0 : selectedCountry.mobile_starts_with) == null ? void 0 : _a[0]) == null ? void 0 : _b.slice(0, 1)) || ""}${"x".repeat(
            (((_c = selectedCountry.phone_number_lengths) == null ? void 0 : _c[0]) || 7) - 1
          )}` : placeholder,
          value: mobile,
          type: "tel",
          name: "mobile",
          "data-testid": "auth_mobile_number_input",
          onChange: (val) => {
            const mobile2 = val.startsWith("0") ? val.substring(1) : val;
            const onlyNumbers = mobile2.replace(/\D/g, "");
            onChange("mobile", onlyNumbers);
          },
          error: !!error,
          ref: ref || mobileRef,
          required,
          minLength: (_d = selectedCountry == null ? void 0 : selectedCountry.phone_number_lengths) == null ? void 0 : _d[0],
          maxLength: (selectedCountry == null ? void 0 : selectedCountry.phone_number_lengths) ? selectedCountry.phone_number_lengths.slice(-1)[0] : void 0,
          rounded: false,
          hideErrorSpace: true
        }
      ) })
    ] }),
    (error || !hideErrorSpace) && /* @__PURE__ */ jsx(
      "p",
      {
        className: `text-error my-1 min-h-[16px] text-xs ${error ? "visible" : "text-transparent"}`,
        children: error
      }
    )
  ] });
};
var MobileInput_default = MobileInput;

export {
  MobileInput_default
};
//# sourceMappingURL=chunk-LQP5437H.mjs.map